// plugins/pinia-tab-router.js
import { PiniaPluginContext } from 'pinia';
import { useRouter, useRoute } from 'vue-router';
import { reactive, toRaw, shallowReactive } from 'vue';
import { getCurrentTabId, getPersistKey } from '@/utils/tab-router-utils';

export const piniaTabRouter = (config) => {
  const {
    excludeStores = [],
    tabIdKey = 'currentIndex',
    fromIdKey = 'fromIndex',
    storage = localStorage,
  } = config || {};
  return (context: PiniaPluginContext) => {
    const { store, options: storeOptions } = context;
    let currentIndex = getCurrentTabId();
    const tabSpecificKey = `${store.$id}-${currentIndex}`;
    const persistConfig = storeOptions?.persist;
    let route = useRoute();

    if (excludeStores.includes(store.$id) || !persistConfig) {
      return store;
    }

    // 2. 修改store的persist配置（关键！）
    if (persistConfig) {
      // 为persist配置添加isolate选项支持
      const shouldIsolate = persistConfig.isolate !== undefined ? persistConfig.isolate : true;

      if (shouldIsolate) {
        // 直接修改storeOptions中的persist配置
        persistConfig.key = tabSpecificKey;
        persistConfig.storage = storage;
      }
      if (!shouldIsolate) {
        return store; // 不隔离，直接返回原始store
      }
    }

    // 那数据比对
    if (
      route.query?.[tabIdKey] &&
      route.query?.[fromIdKey] &&
      route.query?.[tabIdKey] !== route.query?.[fromIdKey]
    ) {
      let currentData = storage.getItem(tabSpecificKey);
      // 如果没有复制过数据，则复制数据
      if (!currentData) {
        // 复制数据
        let formData = storage.getItem(`${store.$id}-${route.query?.[fromIdKey]}`);
        storage.setItem(tabSpecificKey, formData);
      }
    }

    return store;
  };
};
